import { useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import AccountSummaryPage from "components/pages/AccountSummaryPage";
import { useEffect } from "react";

export default function CaptureMabiEStatementsEnrollAccountSummary(props) {
    const context = useBCMSContext();
    const branding = context.state ?? {};

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <AccountSummaryPage />
}